<template>
  <div style="width: 100%;clear: both;">
    <div v-if="this.mode === 'input-only'" class="input-only-area">
      <el-input v-model="customimageName" readonly placeholder="이미지를 선택해주십시오." @click.native="onSelectClick">
        <div class="close-btn" slot="suffix" v-if="customimageName">
          <span @click="onClearClick">
            <i class="fas fa-times-circle" style="cursor: pointer;"></i>
          </span>
        </div>
      </el-input>
    </div>
    <div v-else>
      <el-input style="width: calc(100% - 101px);" v-model="customimageName" readonly placeholder="이미지를 선택해주십시오.">
        <div class="close-btn" slot="suffix" v-if="customimageName">
          <span @click="onClearClick">
            <i class="fas fa-times-circle" style="cursor: pointer;"></i>
          </span>
        </div>
      </el-input>
      <el-button @click="onSelectClick">
        <i class="far fa-file-image"></i>
        이미지 선택
      </el-button>
    </div>
  </div>
</template>

<script>
import DashboardConst from '@/constants/dashboard';

export default {
  name: 'WImageSelectField',
  components: {
  },
  props: {
    value: {},
    mode: {
      type: String,
      default: 'default', // 'input-only'
    },
  },
  data() {
    return {
      customimageId: this.value,
    };
  },
  computed: {
    customimageName() {
      return (this.$store.getters.getCustomimage[this.customimageId] && this.$store.getters.getCustomimage[this.customimageId].customimageName) || '';
    },
  },
  watch: {
    value(val) {
      this.customimageId = val;
    },
  },
  methods: {
    onSelectClick() {
      // 이미지 선택창 팝업
      this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.IMAGE_SELECT_POPUP);
      this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.IMAGE_SELECT, this.onImageSelect);
    },
    onImageSelect(customimage) {
      this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.IMAGE_SELECT, this.onImageSelect);
      this.handleChange((customimage && customimage.customimageId) || null);
    },
    onClearClick(event) {
      this.handleChange(null);
      event.stopPropagation();
    },
    handleChange(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss">
.input-only-area {
  div.el-input {
    width: 100%;

    input.el-input__inner {
      cursor: pointer;
    }
  }
}
.close-btn {
  height: 100%;
  display: flex;
  align-items: center;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/ImageSelectField.vue